(function () {
  if (window.__blueminum_product_ran) return;
  window.__blueminum_product_ran = true;

  const state = {
    variants: [],
    optionNames: [],
    selectedOptions: [],
    currentImageIdx: 0,
    config: { afterAddBehavior: 'stay' }
  };

  const el = {};

  function boot() {
    try {
      loadDom();
      loadConfig();
      loadVariantData();
      loadInitialSelection();
      initGallery();
      initThumbNav();
      initZoom();
      initVariants();
      initQuantity();
      initAccordion();
      initAjaxCart();
      refreshVariantUI();
      syncGalleryToVariant();
    } catch (e) {
      console.error('[Blueminum]', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function loadDom() {
    el.galleryMain = document.querySelector('.product-gallery-main');
    el.images = document.querySelectorAll('.product-gallery-image');
    el.thumbs = document.querySelectorAll('.product-gallery-thumb');
    el.thumbsWrap = document.querySelector('.product-gallery-thumbs-wrap');
    el.thumbsScroller = document.querySelector('.product-gallery-thumbs');
    el.thumbPrev = document.querySelector('.product-gallery-thumbs-nav-prev');
    el.thumbNext = document.querySelector('.product-gallery-thumbs-nav-next');
    el.galleryPrev = document.querySelector('.product-gallery-nav-prev');
    el.galleryNext = document.querySelector('.product-gallery-nav-next');
    el.variantButtons = document.querySelectorAll('.product-variant-option');
    el.variantIdInput = document.getElementById('product-variant-id');
    el.priceDisplay = document.getElementById('product-displayed-price');
    el.priceCompare = document.getElementById('product-displayed-price-compare');
    el.cartBtn = document.getElementById('product-cart-btn');
    el.form = document.getElementById('product-form');
    el.qtyInput = document.getElementById('product-qty-value');
    el.qtyMinus = document.querySelector('.product-qty-minus');
    el.qtyPlus = document.querySelector('.product-qty-plus');
  }

  function loadConfig() {
    const script = document.getElementById('product-config');
    if (!script) return;
    try {
      const cfg = JSON.parse(script.textContent);
      state.config = Object.assign(state.config, cfg);
    } catch (e) {}
  }

  function loadVariantData() {
    const script = document.getElementById('product-variants-data');
    if (!script) return;
    try {
      const data = JSON.parse(script.textContent);
      state.variants = data.variants || [];
      state.optionNames = data.options || [];
    } catch (e) {
      console.error('[Blueminum] Bad variant data:', e);
    }
  }

  function loadInitialSelection() {
    if (el.variantIdInput) {
      const cur = state.variants.find(function (v) { return String(v.id) === String(el.variantIdInput.value); });
      if (cur) { state.selectedOptions = cur.options.slice(); return; }
    }
    if (state.variants[0]) state.selectedOptions = state.variants[0].options.slice();
  }

  function findVariant(opts) {
    return state.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === opts[i]; });
    });
  }

  // ==== Gallery display ====
  function showImage(idx) {
    if (idx < 0 || idx >= el.images.length) return;
    state.currentImageIdx = idx;
    el.images.forEach(function (img, i) { img.classList.toggle('active', i === idx); });
    el.thumbs.forEach(function (t, i) { t.classList.toggle('selected', i === idx); });

    const activeThumb = el.thumbs[idx];
    if (activeThumb && activeThumb.scrollIntoView) {
      try {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      } catch (e) {}
    }
  }

  function initGallery() {
    if (!el.images.length) return;
    el.thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { onThumbClicked(i); });
    });
    if (el.galleryPrev) el.galleryPrev.addEventListener('click', function () {
      const n = state.currentImageIdx === 0 ? el.images.length - 1 : state.currentImageIdx - 1;
      onThumbClicked(n);
    });
    if (el.galleryNext) el.galleryNext.addEventListener('click', function () {
      const n = (state.currentImageIdx + 1) % el.images.length;
      onThumbClicked(n);
    });
  }

  function initThumbNav() {
    if (!el.thumbsWrap || !el.thumbsScroller) return;
    function check() {
      const has = el.thumbsScroller.scrollWidth > el.thumbsScroller.clientWidth + 4;
      el.thumbsWrap.classList.toggle('has-overflow', has);
    }
    check();
    window.addEventListener('resize', check);
    if (el.thumbPrev) el.thumbPrev.addEventListener('click', function () {
      el.thumbsScroller.scrollBy({ left: -el.thumbsScroller.clientWidth * 0.8, behavior: 'smooth' });
    });
    if (el.thumbNext) el.thumbNext.addEventListener('click', function () {
      el.thumbsScroller.scrollBy({ left: el.thumbsScroller.clientWidth * 0.8, behavior: 'smooth' });
    });
  }

  // ==== Hover zoom (desktop only) ====
  function initZoom() {
    if (!el.galleryMain) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

    el.galleryMain.addEventListener('mousemove', function (e) {
      // Skip zoom when hovering nav buttons or the hint pill
      if (e.target.closest('.product-gallery-nav, .product-gallery-hint')) {
        el.galleryMain.classList.remove('is-zooming');
        return;
      }

      el.galleryMain.classList.add('is-zooming');

      const rect = el.galleryMain.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      const cx = Math.max(0, Math.min(100, x));
      const cy = Math.max(0, Math.min(100, y));
      el.galleryMain.style.setProperty('--zoom-x', cx + '%');
      el.galleryMain.style.setProperty('--zoom-y', cy + '%');
    });

    el.galleryMain.addEventListener('mouseleave', function () {
      el.galleryMain.classList.remove('is-zooming');
      el.galleryMain.style.removeProperty('--zoom-x');
      el.galleryMain.style.removeProperty('--zoom-y');
    });
  }

  // ==== Two-way sync ====

  // Gallery image clicked → derive variant from image's assigned variants
  function onThumbClicked(idx) {
    showImage(idx);

    const img = el.images[idx];
    if (!img) return;
    const mediaId = img.dataset.mediaId;
    if (!mediaId) return;

    // Find variants whose featured_media matches this image
    const candidates = state.variants.filter(function (v) {
      return String(v.featured_media_id) === String(mediaId);
    });
    if (candidates.length === 0) return;

    // Prefer a candidate that matches the currently-selected primary option (Size)
    let target = null;
    if (state.selectedOptions[0] != null) {
      target = candidates.find(function (v) { return v.options[0] === state.selectedOptions[0]; });
    }
    if (!target) target = candidates[0];

    // Update option selections to this variant's options — but only change options that this image implies
    // Heuristic: image is tied to Color (or the "shared" option across candidates). Update those, keep others.
    // Simplest correct approach: pick candidate as-is, use its options.
    state.selectedOptions = target.options.slice();
    refreshVariantUI();
    // Do NOT call syncGalleryToVariant here — we're already on the right image
  }

  // Variant option clicked → derive image from resulting variant's featured_media
  function onVariantClicked(btn) {
    if (btn.classList.contains('sold-out')) return;
    const idx = parseInt(btn.dataset.optionIndex, 10);
    const val = btn.dataset.optionValue;
    state.selectedOptions[idx] = val;
    refreshVariantUI();
    syncGalleryToVariant();
  }

  function syncGalleryToVariant() {
    const variant = findVariant(state.selectedOptions);
    if (!variant || !variant.featured_media_id) return;

    let targetIdx = -1;
    el.images.forEach(function (img, i) {
      if (targetIdx === -1 && String(img.dataset.mediaId) === String(variant.featured_media_id)) {
        targetIdx = i;
      }
    });

    if (targetIdx >= 0 && targetIdx !== state.currentImageIdx) {
      showImage(targetIdx);
    }
  }

  // ==== Variant UI refresh ====
  function refreshVariantUI() {
    el.variantButtons.forEach(function (btn) {
      const idx = parseInt(btn.dataset.optionIndex, 10);
      const val = btn.dataset.optionValue;
      btn.classList.toggle('selected', state.selectedOptions[idx] === val);

      // Sold-out check: any available variant with this option value + current sibling selections?
      const test = state.selectedOptions.slice();
      test[idx] = val;
      const anyAvail = state.variants.some(function (v) {
        return v.options.every(function (opv, i) {
          return i === idx ? opv === val : opv === test[i];
        }) && v.available;
      });
      btn.classList.toggle('sold-out', !anyAvail);
    });

    document.querySelectorAll('[data-option-label-for]').forEach(function (lbl) {
      const idx = parseInt(lbl.dataset.optionLabelFor, 10);
      lbl.textContent = state.selectedOptions[idx] || '';
    });

    const variant = findVariant(state.selectedOptions);
    if (!variant) return;

    if (el.variantIdInput) el.variantIdInput.value = variant.id;
    if (el.priceDisplay) el.priceDisplay.textContent = variant.price;
    if (el.priceCompare) {
      if (variant.compare_at_price && variant.compare_at_price !== variant.price) {
        el.priceCompare.textContent = variant.compare_at_price;
        el.priceCompare.style.display = '';
      } else {
        el.priceCompare.style.display = 'none';
      }
    }
    if (el.cartBtn && !el.cartBtn.classList.contains('is-added')) {
      const originalText = el.cartBtn.dataset.textAvailable || 'Add to cart';
      el.cartBtn.disabled = !variant.available;
      el.cartBtn.textContent = variant.available ? originalText : 'Sold out';
    }
  }

  function initVariants() {
    el.variantButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { onVariantClicked(btn); });
    });
  }

  // ==== Quantity ====
  function initQuantity() {
    if (!el.qtyInput) return;
    if (el.qtyMinus) el.qtyMinus.addEventListener('click', function () {
      const v = parseInt(el.qtyInput.value, 10) || 1;
      if (v > 1) el.qtyInput.value = v - 1;
    });
    if (el.qtyPlus) el.qtyPlus.addEventListener('click', function () {
      const v = parseInt(el.qtyInput.value, 10) || 1;
      el.qtyInput.value = v + 1;
    });
  }

  // ==== Accordion ====
  function initAccordion() {
    document.querySelectorAll('.product-spec-question').forEach(function (q) {
      q.addEventListener('click', function (e) {
        e.preventDefault();
        const parent = q.closest('.product-spec-item');
        if (parent) parent.classList.toggle('is-open');
      });
    });
  }

  // ==== Ajax Cart ====
  function initAjaxCart() {
    if (!el.form || !el.cartBtn) return;

    el.form.addEventListener('submit', function (e) {
      // If merchant configured standard form submission, don't hijack
      if (state.config.afterAddBehavior === 'standard') return;

      e.preventDefault();
      if (el.cartBtn.disabled) return;

      const originalText = el.cartBtn.dataset.textAvailable || 'Add to cart';
      el.cartBtn.disabled = true;
      el.cartBtn.textContent = 'Adding…';

      const formData = new FormData(el.form);

      // Request fresh section HTML alongside the add — Shopify's Section
      // Rendering API baked into /cart/add.js. Response will include a
      // `sections` object with rendered HTML for each named section that
      // exists in the theme; unknown names are silently omitted.
      formData.append('sections', 'cart-drawer-section,cart-drawer,cart-drawer-inner,cart-icon-bubble,cart-notification,cart-live-region-text,header');
      formData.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        cache: 'no-store',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (addResponse) {
          el.cartBtn.classList.add('is-added');
          el.cartBtn.textContent = 'Added ✓';

          // Apply fresh section HTML BEFORE fetching cart total.
          // This replaces the stale drawer content with a server-rendered
          // version reflecting the just-added item.
          if (addResponse && addResponse.sections) {
            applySections(addResponse.sections);
          }

          return fetch('/cart.js', {
            cache: 'no-store',
            headers: { 'Accept': 'application/json' }
          });
        })
        .then(function (res) { return res ? res.json() : null; })
        .then(function (cart) {
          if (cart) updateCartDisplays(cart);

          if (state.config.afterAddBehavior === 'go_to_cart') {
            setTimeout(function () { window.location.href = '/cart'; }, 500);
            return;
          }

          setTimeout(function () {
            el.cartBtn.classList.remove('is-added');
            el.cartBtn.disabled = false;
            el.cartBtn.textContent = originalText;
          }, 1600);
        })
        .catch(function (err) {
          console.error('[Blueminum] Cart error:', err);
          el.cartBtn.textContent = 'Try again';
          setTimeout(function () {
            el.cartBtn.disabled = false;
            el.cartBtn.textContent = originalText;
          }, 2000);
        });
    });
  }

  function updateCartDisplays(cart) {
    const count = cart.item_count;

    // Legacy count-selector updates (safe leaf-only)
    updateCountSelectors(count);

    // Save to session storage (Savor's cart-icon reads on bfcache restore)
    saveCartCountToStorage(count);

    // Dispatch cart events — updates cart-icon count via renderCartBubble
    dispatchStandardCartEvent(cart);
    dispatchGenericCartEvents(cart);
  }

  function applySections(sections) {
    // Apply fresh section HTML returned from /cart/add.js. Each key is the
    // section name (e.g. "cart-drawer-section") and value is the rendered HTML.
    // Sections we requested that don't exist in the theme are simply not
    // included in the response, so iterating whatever we got is safe.
    let appliedAny = false;
    for (const name in sections) {
      const html = sections[name];
      if (!html) continue;

      const target = document.getElementById('shopify-section-' + name);
      if (!target) continue;

      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const wrapper = doc.body.firstElementChild;
        if (wrapper) {
          target.innerHTML = wrapper.innerHTML;
        } else {
          target.innerHTML = html;
        }
        appliedAny = true;
      } catch (e) {
        console.warn('[Blueminum] Failed to apply section ' + name + ':', e);
      }
    }

    // Belt-and-suspenders: if none of the requested sections matched
    // (weird theme structure, section names don't align), fall back to
    // fetching the current page and extracting the cart drawer from it.
    if (!appliedAny) {
      refreshCartDrawerFromFullPage();
    }
  }

  function refreshCartDrawerFromFullPage() {
    // Fallback path — only invoked if the sections-in-response mechanism
    // didn't find anything to apply. Uses a full-page fetch of the current
    // URL, extracts the cart-drawer section from the fresh HTML, and swaps
    // it into the current DOM. Slower than the sections API but guaranteed
    // to work with any theme that renders the drawer in every page's layout.
    fetch(window.location.pathname, {
      cache: 'no-store',
      credentials: 'same-origin'
    })
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) {
        if (!html) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const targetIds = [
          'shopify-section-cart-drawer-section',
          'shopify-section-cart-drawer',
          'cart-drawer'
        ];

        for (const id of targetIds) {
          const freshEl = doc.getElementById(id);
          const currentEl = document.getElementById(id);
          if (freshEl && currentEl) {
            currentEl.innerHTML = freshEl.innerHTML;
            console.log('[Blueminum] Cart drawer refreshed via full-page fallback');
            return;
          }
        }
      })
      .catch(function () { /* silent */ });
  }

  function updateCountSelectors(count) {
    const selectors = [
      '[data-cart-count]',
      '.cart-count-bubble',
      '.cart-count',
      '.cart-item-count',
      '.header__cart-count',
      '.header-cart-count',
      '#cart-count',
      '#CartCount',
      '[data-header-cart-count]',
      '.js-cart-count',
      '.site-header__cart-count',
      '[data-cart-item-count]',
      '.cart-link__bubble',
      '.cart-link__count',
      '.cart-page-link__count',
      '[ref="cartBubbleCount"]',
      '[data-ref="cartBubbleCount"]'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (node) {
        // SAFETY: only update leaf nodes to avoid destroying nested ref
        // elements inside wrappers (Savor MissingRefError protection)
        if (node.children.length !== 0) return;
        node.textContent = count;
        if (count > 0) {
          node.removeAttribute('hidden');
          node.classList.remove('hidden', 'visually-hidden');
        }
      });
    });
  }

  function saveCartCountToStorage(count) {
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({
        value: String(count),
        timestamp: Date.now()
      }));
    } catch (e) {}
  }

  function dispatchStandardCartEvent(cart) {
    const cartUpdatePromise = Promise.resolve({
      cart: {
        totalQuantity: cart.item_count,
        id: cart.token,
        items: cart.items || [],
        note: cart.note
      },
      detail: {
        itemCount: cart.item_count,
        didError: false
      }
    });

    const eventNames = [
      'cart:update',
      'cart:lines:update',
      'cart-lines-update',
      'cartLinesUpdate',
      'cart:refresh'
    ];
    eventNames.forEach(function (name) {
      const evt = new Event(name, { bubbles: true, composed: true });
      evt.action = 'add';
      evt.promise = cartUpdatePromise;
      document.dispatchEvent(evt);
    });
  }

  function dispatchGenericCartEvents(cart) {
    const events = [
      'cart:updated', 'cart:build', 'cart:added',
      'shopify:cart:updated', 'theme:cart:updated', 'theme:cart:change',
      'theme:cart:open', 'cart-drawer:open', 'ajaxProduct:added',
      'on:cart:added'
    ];
    events.forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { detail: cart, bubbles: true }));
      window.dispatchEvent(new CustomEvent(name, { detail: cart }));
      if (el.form) el.form.dispatchEvent(new CustomEvent(name, { detail: cart, bubbles: true }));
    });

    if (window.PubSub && typeof window.PubSub.publish === 'function') {
      window.PubSub.publish('cart:updated', cart);
      window.PubSub.publish('cart-items:change', cart);
    }
  }
})();